import { Component, Vue, Prop } from 'vue-property-decorator';
import { MiDialogOptions } from '@/components/MiDialog/MiDialog';

@Component<MiToggle>({ })
export default class MiToggle extends Vue {
  @Prop({ default: false })
  protected value!: string | boolean;

  @Prop({ default: false })
  protected falseValue!: string | boolean;

  @Prop({ default: 'false' })
  protected falseText!: string;

  @Prop({ default: false })
  protected trueValue!: string | boolean;

  @Prop({ default: 'true' })
  protected trueText!: string;

  @Prop({ default: 'Failed to update' })
  protected titleUpdateFailed!: string;

  protected isLoading = false;

  protected currentValue: string | boolean = false;

  protected mounted(): void {
    this.currentValue = this.value;
  }

  protected toggle(): void {
    this.currentValue = this.currentValue === this.trueValue ? this.falseValue : this.trueValue;
    this.isLoading = true;
    const event: ToggleUpdateEvent = {
      value: this.currentValue,
      updateSuccessHandler: () => this.updateSuccess(),
      updateFailureHandler: () => this.updateFailed(),
    };
    this.$emit('update', event);
  }

  protected updateSuccess(): void {
    this.isLoading = false;
  }

  protected updateFailed(): void {
    this.isLoading = false;
    this.currentValue = this.currentValue === this.trueValue ? this.falseValue : this.trueValue;
    this.$store.dispatch('openDialog', this.updateFailedDialogOptions);
  }

  protected get updateFailedDialogOptions(): MiDialogOptions {
    return {
      text: this.titleUpdateFailed,
      type: 'error',
      buttons: {
        confirm: {
          text: 'Close',
          action: () => {
            this.$store.dispatch('closeDialog');
          },
        },
      },
    };
  }
}

export interface ToggleUpdateEvent {
  value: string | boolean;
  updateSuccessHandler: () => void;
  updateFailureHandler: () => void;
}
